module.exports = __webpack_public_path__ + "img/No-Image-Placeholder.eb243818.svg";